import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import UserSearchForm from '../components/UserSearchForm';
import { ApplicationState } from 'reducers';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import OrderSearchForm from '../components/OrderSearchForm';
import ProductSearchForm from '../components/ProductSearchForm';
import { Permissions } from '@root/utils/Auth';
import Env from '@root/utils/Env';


interface Props {
    permissions: string[] | null;
}

type PropType = Props & InjectedIntlProps;

class Dashboard extends React.Component<PropType> {

    private renderBox(title: string, content: any) {
        return (
            <div className="col-sm-6">
                <div className="ibox">
                    <div className="ibox-title">
                        <h5>{title}</h5>
                    </div>
                    <div className="ibox-content">
                        {content}
                    </div>
                </div>
            </div>
        );
    }

    private renderUserForm() {
        return this.renderBox(this.props.intl.formatMessage({id: 'module.dashboard.block.users'}), <UserSearchForm />);
    }

    private renderOrderForm() {
        return this.renderBox(this.props.intl.formatMessage({id: 'module.dashboard.block.orders'}), <OrderSearchForm />);
    }

    private renderProductForm() {
        return this.renderBox(this.props.intl.formatMessage({id: 'module.dashboard.block.products'}), <ProductSearchForm />);
    }

    private renderStats() {
        return this.renderBox(this.props.intl.formatMessage({id: 'module.dashboard.block.stats'}), (
            <a className="btn btn-primary btn-block" href={Env.dashboardUrl} target="_blank">
                {this.props.intl.formatMessage({id: 'common.open'})}
            </a>
        ));
    }

    private hasPermission(permission: string) {
        return this.props.permissions && this.props.permissions.includes(permission.toLowerCase());
    }

    public render() {
        return (
            <div className="row dropdownPadding">
                {this.hasPermission(Permissions.orders) && this.renderOrderForm()}
                {this.hasPermission(Permissions.users) && this.renderUserForm()}
                {this.hasPermission(Permissions.products) && this.renderProductForm()}
                {this.hasPermission(Permissions.dashboard) && this.renderStats()}
            </div>
        );
    }
}

const mapStateToProps = ({ auth }: ApplicationState) => {
    return {
        permissions: auth.permissions,
    };
};

export default compose(
    injectIntl,
    connect(mapStateToProps),
)(Dashboard);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/pages/Dashboard.tsx